export default __webpack_public_path__ + "static/media/sc16.594ab33b.png";